import styled         from "styled-components";

export const StyledStatus = styled.div<{color: string}>`
  display: flex;
  align-items: center;
  ${({color}) => `color: ${color};`}
  p {
    margin: 0 0.8rem 0 0.8rem;
  }
`;